import { getLandingState, getMainUserState } from '@/modules/main/selector';
import { RwdTypography } from '@/modules/rwdGame/components/RwdTypography';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const DisplayName = () => {
    const { Username: serverName } = useSelector(getMainUserState);
    const { username: landingName } = useSelector(getLandingState);
    const [name, setName] = useState('');

    useEffect(() => {
        setName(landingName ?? serverName);
    }, [serverName, landingName]);
    return (
        <RwdTypography stepIndex={-1} landscapeStepIndex={3}>
            {name}
        </RwdTypography>
    );
};
